import React, { useState, useEffect } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
} from "../../../components/commons";
import TrialBalanceHeader from "../../../components/Reports/TrialBalance/TrialBalanceHeader";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  getTrialBalanceAction,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
  resetTrialBalance,
} from "../../../redux/reports";
import {
  TotalBalancetype,
  TrialBalanceType,
} from "../../../redux/reports/reportsType";
import { GetTrialBalancePayloadType } from "../../../commonTypes/reportsTypes";
import { formatDate, handleDate } from "../../../utils/commonFunctions";
import { TRIAL_BALANCE_HEADERS } from "../../../constant/tableHeadersConstants/reportsConstant/trialBalanceConstants/trialBalanceHeaderConst";
import TrialBalanceTable from "../../../components/Reports/TrialBalance/TrialBalanceTable/TrialBalanceTable";
import { TrialBalanceImage } from "../../../assets/images";
import { resetSession } from "../../../redux/auth";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Excel } from "../../../components/Icon";
import moment from "moment";
import FileSaver from "file-saver";
import { downloadTrailBalanceApi } from "../../../apis/reportsApis";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { toast, Toaster } from "react-hot-toast";
import ViewEditCustomerSuplierModal from "../../../components/Reports/LedgerStatement/ViewEditCustomerSuplierModal";
import { GetSingleCustomerSupplierListPayloadType } from "../../../commonTypes/clientSettingsTypes";
import {
  getSingleCustomerSupplierAction,
  resetSingleCustomerSupplier,
} from "../../../redux/clientSettings";
import { CustomerSupplierListType } from "../../../redux/clientSettings/clientSettingTypes";
import SkeltonElement from "../../../components/commons/SkeltonLoader/SkeltonElement";

type AppProps = {
  history?: any;
  token: string | null;
  trialBalance: [] | TrialBalanceType[];
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  totalBalances: TotalBalancetype;
  customerSuplierFetching: boolean;
  currencySign: string | undefined;
  companyName: string;
  singleCustomerSupplier: CustomerSupplierListType;
  dispatchGetTrialBalanceDataAction: (data: GetTrialBalancePayloadType) => void;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchResetTrialBalanceAction: () => void;
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchResetSingleCustomerSupplier: () => void;
  dispatchResetReportsFetchingAction: () => void;
  allCustomerSuplierList: any;
};

const TrialBalance = ({
  history,
  token,
  trialBalance,
  fetching,
  success,
  error,
  statusCode,
  totalBalances,
  customerSuplierFetching,
  dispatchGetTrialBalanceDataAction,
  dispatchResetTrialBalanceAction,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchResetSession,
  dispatchGetSingleCustomerSupplierAction,
  singleCustomerSupplier,
  dispatchResetSingleCustomerSupplier,
  dispatchResetReportsFetchingAction,
  currencySign,
  companyName,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyName;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLedgerStatementPresent, setIsLedgerStatementPresent] =
    useMenuCheck();
  const [isEditCustomerSupplierPresent, setIsEditCustomerSupplierPresent] =
    useMenuCheck();
  const [isDownloadTrialPresent, setIsDownloadTrialPresent] = useMenuCheck();
  const [redirectToCustomerSuplier, setRedirectToCustomerSuplier] =
    useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);

  useEffect(() => {
    setIsLedgerStatementPresent("Ledger Statement", "menu");
    setIsDownloadTrialPresent("Download Trial Balance", "menu");
    setIsEditCustomerSupplierPresent("Edit Customer/Supplier", "menu");
    dispatchResetTrialBalanceAction();
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetSingleCustomerSupplier();
    dispatchResetReportsFetchingAction();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (displayEndDate != endDate || startDate != displayStartDate) {
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }
    //eslint-disable-next-line
  }, [trialBalance]);

  useEffect(() => {
    if (!showModal) {
      dispatchResetSingleCustomerSupplier();
    }
    //eslint-disable-next-line
  }, [showModal]);

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmitData = () => {
    let finalData: GetTrialBalancePayloadType = {
      token,
      client_code,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
    };

    dispatchGetTrialBalanceDataAction(finalData);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  const renderDownloadInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Download Excel
      </Tooltip>
    );
  };

  const handlePrepareDownload = () => {
    let params: GetTrialBalancePayloadType = {
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      client_code: client_code,
      token,
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: GetTrialBalancePayloadType) => {
    let reportName = company_name
      ? company_name +
        "-" +
        moment(startDate).format("DD-MM-YYYY") +
        " to " +
        moment(endDate).format("DD-MM-YYYY") +
        ".xlsx"
      : "report";
    downloadTrailBalanceApi(params).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handleCustomerSuplierDetailsData = (data: number) => {
    setShowModal(!showModal);
    if (token && client_code) {
      const finaldata = {
        token,
        client_code,
        customerSupplierId: data,
      };
      dispatchGetSingleCustomerSupplierAction(finaldata);
    }
  };
  const handleCustomerSupliertoogle = () => {
    setShowModal(!showModal);
    if (redirectToCustomerSuplier) {
      handleSubmitData();
      setRedirectToCustomerSuplier(false);
    }
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Trial Balance"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="report-card mt-4 pt-3">
        <div className="inside-report-card">
          <TrialBalanceHeader
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleSubmitData={handleSubmitData}
          />
          <hr className="mt-4 mb-4" />
          {trialBalance && trialBalance?.length === 0 && !fetching ? (
            <EmptyListPage
              title="No Balance Found!"
              text="Choose start date and end date to get Trial Balance."
              image={TrialBalanceImage}
              imageWidth="30%"
            />
          ) : (
            <>
              <h5 className="text-center ">Trial Balance </h5>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <h3
                  className={
                    isDownloadTrialPresent ? "text-center ml-4" : "text-center"
                  }
                >
                  {company_name}
                </h3>
                <div className=" d-flex justify-content-end">
                  {isDownloadTrialPresent && (
                    <div className="mt-1">
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={renderDownloadInvoiceToolTip}
                      >
                        <button
                          style={{ border: "none", marginTop: "-6px" }}
                          onClick={handlePrepareDownload}
                        >
                          <Excel />
                        </button>
                      </OverlayTrigger>
                    </div>
                  )}
                </div>
              </div>

              <div className="d-flex justify-content-center mt-3">
                <h6 className="text-center mr-4">
                  Start Date:{" "}
                  {fetching ? (
                    <span>
                      <SkeltonElement type="title" />
                    </span>
                  ) : (
                    <span className="font-weight-bolder">
                      {displayStartDate}
                    </span>
                  )}
                </h6>
                <h6 className="text-center">
                  End Date:{" "}
                  {fetching ? (
                    <span>
                      <SkeltonElement type="title" />
                    </span>
                  ) : (
                    <span className="font-weight-bolder">{displayEndDate}</span>
                  )}
                </h6>
              </div>
              <TrialBalanceTable
                fetching={fetching}
                trialBalanceData={trialBalance}
                client_code={client_code}
                company_name={company_name}
                tableHeaders={TRIAL_BALANCE_HEADERS}
                totalBalances={totalBalances}
                start_date={startDate}
                end_date={endDate}
                isLedgerStatementPresent={isLedgerStatementPresent}
                handleCustomerSuplierDetailsData={
                  handleCustomerSuplierDetailsData
                }
                currencySign={currencySign}
              />
            </>
          )}
        </div>
      </div>
      {showModal && (
        <ViewEditCustomerSuplierModal
          isOpen={showModal}
          fetching={customerSuplierFetching}
          isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
          setRedirectToCustomerSuplier={setRedirectToCustomerSuplier}
          client_code={client_code}
          company_name={company_name}
          toggle={handleCustomerSupliertoogle}
          singleCustomerSupplier={singleCustomerSupplier}
          currencySign={currencySign}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  trialBalance: state.reports.trialBalance,
  fetching: state.reports.fetching,
  error: state.reports.error,
  statusCode: state.reports.statusCode,
  success: state.reports.success,
  totalBalances: state.reports.totalBalances,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  allCustomerSuplierList: state.clientSettings.customerSupplierList,
  customerSuplierFetching: state.clientSettings.fetching,
  currencySign: state.auth.currencySign,
  companyName: state.auth.companyName,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchResetTrialBalanceAction: () => dispatch(resetTrialBalance()),
  dispatchGetTrialBalanceDataAction: (data: GetTrialBalancePayloadType) =>
    dispatch(getTrialBalanceAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSingleCustomerSupplier: () =>
    dispatch(resetSingleCustomerSupplier()),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrialBalance);
